import { useState } from "react";
import { useMediaQuery } from "@mui/material";

export const MOBILE_BREAKPOINT = "(max-width:700px)";

export type MobileAssignmentTab = "unassigned" | "assign-to";

export function useMobileWizard() {
	const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
	const [activeTab, setActiveTab] = useState<MobileAssignmentTab>("unassigned");

	return { isMobile, activeTab, setActiveTab };
}
